export const homeFaqs = [
  {
    q: "How do I use a coupon code?",
    a: "Find the coupon you want, click 'See Coupon' to reveal the code, then copy it and paste it at checkout on the store's website.",
  },
  {
    q: "Are the coupons verified?",
    a: "Yes, our team verifies coupons daily. Look for the 'Verified' badge on coupons that have been recently confirmed to work.",
  },
  {
    q: "Is DealBeez free to use?",
    a: "Absolutely! DealBeez is 100% free. We may earn a small affiliate commission from stores when you use our links, at no cost to you.",
  },
  {
    q: "How often are new deals added?",
    a: "We add new coupons and deals every hour. Our community also submits deals which are reviewed and published within 24 hours.",
  },
];
